import { iconUrlByTicker } from "../../../assets/tickerAssetsIndex";

export const BondDetailLogo = ({ className, issuerTicker }: { className?: string; issuerTicker: string }) => {
  const logoImageUrl = iconUrlByTicker(issuerTicker);

  return (
    <div className={className}>
      {logoImageUrl ? <img alt="" style={{ height: "54px" }} src={logoImageUrl} /> : null}
    </div>
  );
};
